import React from "react";

const ErrorValidation = ({ errorMessage }) => {
  return (
    <>
      <span className="text-[#BA1F1A] font-roboto font-normal text-xs">
        {errorMessage}
      </span>
    </>
  );
};

export default ErrorValidation;
